import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {rbacActions} from "../../../config/rbac/actions.ts";
import {DeleteRecordButton} from "../buttons/DeleteRecordButton.tsx";
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";
import {FilterRecordsButton} from "../buttons/FilterRecordsButton.tsx";
import {AddRecordButton} from "../buttons/AddRecordButton.tsx";
import {GeneratePricesButton} from "../../test-data-generator/buttons/GeneratePricesButton.tsx";

const useTools = () => {
    const {allowedActions} = useVerifiedPermissions();

    const tools = [<FilterRecordsButton key='filter'/>, <ReloadRecordsButton key='reload'/>];

    if (allowedActions.includes(rbacActions.DeletePrice)) {
        tools.push(<DeleteRecordButton key='delete'/>);
    }

    if (allowedActions.includes(rbacActions.CreatePrice)) {
        tools.push(<AddRecordButton key='add'/>);
        tools.push(<GeneratePricesButton key='generate'/>);
    }

    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get('Prices')}
            tools={useTools()}
        />
    );
};
